export const FIRST_HYPOTHESIZED_FUNC__DATE_MESSAGE_V1 = 'Same as date introduced';
export const FIRST_HYPOTHESIZED_FUNC__DATE_MESSAGE_V2 = 'Same as baseline date';

export const FREQUENCY_OPTIONS = [
  { value: 'Daily', label: 'Daily' },
  { value: 'Twice a week', label: 'Twice a week' },
  { value: 'Once a week', label: 'Once a week' },
  { value: 'Bi monthly', label: 'Bi monthly' },
  { value: 'Monthly', label: 'Monthly' },
] as const;
